export const DEFAULT_CHIRP_TIMEOUT = 20000;